import { type DocumentNode, gql } from '@apollo/client';

const allFieldDefinitionsQuery: DocumentNode = gql`
  query all_available_fields($id: ID) {
    allFieldDefs(id: $id) {
      edges {
        node {
          id
          name
          slug
          dataType
          fieldType
          isSystemField
          isRequired
          isMultivalued
          isEditable
          highlightIfBlank
          dateDisplayStyle
          choices
          scope
        }
      }
    }
  }
`;

export default allFieldDefinitionsQuery;
